export enum MatchingStatus {
  Ready = "ready",
  ActivityClosed = "activity_closed"
}
